module.exports = "<!--ui modal declaration-->"


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fino/ng1-modal/src/modal.declaration.html
// module id = 1523
// module chunks = 12